<template>
  <div>
    <v-runtime-template :template="includeTemplate"/>
    <SurveyPopup v-if="visible" @satisfaction="fnSatisfaction"/>
  </div>
</template>
<script>

import VRuntimeTemplate from 'v-runtime-template'
import wepHtmlToString from '@/plugins/_common/WepHtmlToString'
import { isEmpty } from 'lodash'
import SurveyPopup from '~pages/contents/main/SurveyPopup.vue'

export default {
  name: 'Enter',
  metaInfo () {
  },
  components: {
    VRuntimeTemplate,
    SurveyPopup
  },
  data () {
    return {
      includeHtml: '',
      basePath: this.getStore('mmpAuth').state.basePath,
      visible: false,
      wepSets: this.getStore('mmpAuth').state.wepSets,
      cmntList: [],
      wepApcId: this.getStore('mmpAuth').state.session.userId,
      wepId: this.getStore('mmpAuth').state.session.wepId,
      panoptoUrl: '',
      isMock: false
    }
  },
  computed: {
    includeTemplate () {
      return this.includeHtml
    }
  },
  beforeUpdate () {
  },
  updated () {
  },
  mounted () {
  },
  async created () {
    let params = {
      wepId: this.wepId,
      langId: localStorage.getItem('language')
    }

    let resultInfo = await this.$http.mmp.getTzTime(this, params)
    let currDay = resultInfo.data.data
    if (this.wepSets.mocktUseYn === 'Y' && currDay >= this.wepSets.mocktStartDtm && currDay <= this.wepSets.mocktEndDtm) {
      this.isMock = true
    }

    if (this.wepSets.videoTrnsTyp === '02' ) {
      this.getTemplate('wepAgenda.html', '0', 'classnow')
    } else if (this.wepSets.videoTrnsTyp === '03' ) {
      this.getTemplate('wepAgenda.html', '0', 'classnow')
    } else {
      if (isEmpty(wepHtmlToString.mainTemplate)) {
        this.getEmptyTemplate('wepEnter.html')
      } else {
        this.includeHtml = wepHtmlToString.mainTemplate
      }
      this.fnPanoptoPlayer()
    }
  },
  methods: {
    fnPanoptoPlayer () {
      this.panoptoUrl = this.basePath + '/panoptoPlayer'
      window.open(this.panoptoUrl, 'panopto', 'width=1024,height=768')
    },
    getEmptyTemplate (resourceUrl) {
      resourceUrl = this.getTemplatePath(resourceUrl)
      this.$http.loadRes(resourceUrl).then( (res) => {
        wepHtmlToString.mainTemplate = res
        this.includeHtml = wepHtmlToString.mainTemplate
      })
    },
    async fnSatisfaction (arg) {
      if (arg) {
        // 평가유무 확인
        let params = {
          survyScCd: '02',
          wepApcId: this.getStore('mmpAuth').state.session.userId
        }

        let resultInfo = await this.$http.mmp.evalSurveyYn(this, params)
        if (resultInfo.data.status !== 'OK') {
          this.commAlert(this.$t('WEP00027'))
        } else {
          if (resultInfo.data.data.evalYn === 'N') {
            this.visible = arg
            this.setOverflow(this.visible)
          } else {
            this.commAlert(this.$t('WEP00026'))
          }
        }
      } else {
        this.visible = arg
        this.setOverflow(this.visible)
      }
    },
    async fnInsert () {
      this.cmntCntnt = document.getElementById('cmntCntnt').value
      if (this.cmntCntnt === '') {
        this.commAlert(this.$t('WEP00032'))
      } else {
        let params = {
          wepApcId: this.wepApcId,
          wepId: this.wepId,
          lastCmntSno: this.lastCmntSno,
          cmntCntnt: this.cmntCntnt
        }
        let result = await this.$http.mmp.onAirComment(this, params)
        this.cmntCntnt = ''
        this.fnLoad(result)
      }
    },
    async fnLoad () {
      let params = {
        wepApcId: this.getStore('mmpAuth').state.session.userId,
        wepId: this.getStore('mmpAuth').state.saveId,
        lastCmntSno: this.lastCmntSno,
        cmntCntnt: ''
      }
      let list = await this.$http.mmp.onAirComment(this, params)
      this.cmntList.put(list)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/contents/main/Enter.vue